import '../document/styles.scss';
import './styles.scss';

import each from 'lodash/each';

import moment from 'moment';

export default {
    name: 'AnnotationDetailPage',

    data() {
        return {
            ready: false,
            fetchError: false,
            page: 1,
            scribbleCreated: false, 
            scribble: null,
            scribbleLoaded: false,
            loaded: false,
            documentLoadedUri: false,
            frameId: null,
            added: false,
            mode: 'zoom',
            pages: 1, 
            poll: null,
            context: {
                primaryColor: '#FF0000',
                lineThickness: '5',
                opacity: 1.0,
                shape: 'square',
                stampId: '1'
            }
        };
    },

    computed: {
        list() {
            return this.$store.getters.sharedAnnotations;
        },

        id() {
            return Number(this.$route.params.id);
        },

        scribbleUrl() {
            if (this.ready) { return '/js/scribble/public/scribble.html' ; }
            return 'about:blank';
        },

        desktop() {
            return this.$store.state.desktop;
        },

        user() {
            return this.$store.getters.getUser;
        },

        stamps() {
            return this.$store.getters.getStampCache;
        },

        stampsList() {
            return this.$store.getters.getStamps;
        },

        stampsReady() {
            return this.$store.getters.getAllStampsLoaded;
        },        

        canNext() {
            return this.page < this.pages;
        },

        canPrevious() {
            return this.page > 1;
        },

        modified() {
            return moment(this.annotation.modified).format('x');
        },

        document() {
            if (this.annotation) {
                return this.$store.getters.getCurrentDocument(this.annotation.document_id);
            }
        },

        documentUri() {
            if (this.annotation) {
                return this.$store.getters.getFromCache(this.annotation.document_id);
            }
        },

        annotation() {
            return this.$store.getters.sharedAnnotation(this.id);
        }
    },

    watch: {
        list(newValue) {
            this.$store.commit('setMenuItems', this.list);
        },

        id(newValue) {
            this.added = false;
        }
    },

    methods: {

        onResize() {
            this.changePage(this.page);
        },

        next() {
            if (this.canNext) {
                this.changePage(this.page + 1);
            }
        },

        previous() {
            if (this.canPrevious) {
                this.changePage(this.page - 1);
            }
        },

        changePage(page) {
            this.page = parseInt(page, 10);
            this.sendMessage('setPage', { page: parseInt(page, 10) });
        },

        sendMessage(command, data) {
            if (this.scribble) {
                this.scribble.postMessage({ command, data }, '*');
            }
        },

        setupStamps() {
            if (this.stamps) {
                this.$nextTick(() => {
                    if (this.stamps.length > 0) { this.setAnnotation(); }
                });
            }
        },

        async setAnnotation() {
            // We have to wait about a second before Scribble is actually ready.
            if (!this.loaded && this.annotation && this.annotation.hasOwnProperty('json')) {
                const annotations = JSON.parse(this.annotation.json);
                const stamps = await this.$store.dispatch('loadAssetsForAnnotations', annotations);
                this.sendMessage('setLocalAssets', stamps);
                this.sendMessage('setAnnotation', { editable: false, annotation: annotations });
                this.loaded = true;
            }
        },

        setupScribble() {
            this.scribble = document.querySelector('iframe').contentWindow;
            this.scribble.addEventListener('resize', this.onResize);
            this.sendMessage('setDocument', { document: this.documentLoadedUri });
            this.scribbleLoaded = true;
        },

        checkForReady() {
            return false;
        },

        handleMessage(evt) {
            const { command, data } = evt.data;
            if (command === 'init') { this.setupScribble(); }
            if (command === 'setPageCount') { this.pages = data.pages; }
            if (command === 'ready') { this.setAnnotation(); }
        },

        async getDocument() {
            if (!this.ready && this.id) {
                console.info(`Getting document for ${this.frameId}`);
                this.fetchError = false;
                const blob = await this.$store.dispatch('fetchDocumentURI', this.annotation.document_id);
                if (blob) {
                    this.documentLoadedUri = blob;
                    this.ready = true;
                } else {
                    this.fetchError = 'Your file could not be downloaded. Please check your internet connection and try again.';
                }
            }
        }
    },

    mounted() {
        console.log("Detail mounted...");
        this.$store.dispatch('fetchAllStamps');
        this.$store.commit('setActiveMenu', true);
        this.getDocument();
    },

    created() {
        this.frameId = Math.floor(Math.random() * 100);
        this.$store.commit('setMenuItems', this.list);
        this.$store.commit('setMenuDetails', {
            title: 'Annotations Shared with You',
            slug: 'annotations',
            back_url: '/annotations',
        });
        this.$store.commit('resetMessage');
        this.$store.commit('resetSearch');
        this.$store.dispatch('getSharedAnnotations');
        window.addEventListener('message', this.handleMessage, true);
        this.poll = window.setInterval(() => { console.info('Refreshing annotations from detail...'); this.$store.dispatch('getSharedAnnotations'); }, 10000);
    },

    beforeDestroy() {
        window.clearInterval(this.poll);
        window.removeEventListener('message', this.handleMessage, true);
        if (this.scribble) {
            this.scribble.removeEventListener('resize', this.onResize);
            this.scribble = null;
        }
    }

};